import Vue from 'vue';
import VueAxios from 'vue-axios';
import { AxiosInstance } from 'axios';
import { AxiosBuilder } from '@gis/common/dist/AxiosSetup';
import AuthService from '@/utils/AuthService';


var _axios = new AxiosBuilder(process.env.VUE_APP_API_BASE_URL)
    .withAccessToken(AuthService.getAccessToken())
    .build();

Vue.use(VueAxios, _axios);

export default _axios;

window['axios'] = _axios;

declare global {
    var axios: AxiosInstance
}